import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addBeat, getBeatOutlets, getBeats, getOrgUnits, getTerritoryByOrgUnit, getTownFilter, getTownByOrgUnitIDTerritoryId, updateBeat, getAllTerritory, getBeatById } from "./BeatRepository";
import { showToast } from "../../../../utils/toastUtils";

export const useTerritoryByOrgUnitData = ({
    OrgUnitId = null,
    enable = false,
}: { OrgUnitId?: number | any; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["TERR_BY_ORG_UNIT", OrgUnitId],
        queryFn: () => getTerritoryByOrgUnit(OrgUnitId),
        enabled: enable,
        retry: false,
    });
};
export const useTownByOrgUnitIDTerritoryIdData = ({
    params = {},
    enable = false,
}: {  params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["TERR_BY_ORG_UNIT", params],
        queryFn: () => getTownByOrgUnitIDTerritoryId(params),
        enabled: enable,
        retry: false,
    });
};
export const useBeatData = ({
    params = {},
    enable = false,

}: { params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["BEATS", params],
        queryFn: () => getBeats(params),
        enabled: enable,
        retry: false,
    });
}
export const useGetOrgUnitsData = ({ enable = false }: { enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["ORG_DATA"],
        queryFn: getOrgUnits,
        enabled: enable,
        retry: false
    });
};

export const useAddBeat = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addBeat,
        onSuccess: (data) => {
            showToast.success("Beat Added Successfully!");
            queryClient.invalidateQueries({ queryKey: ["BEATS"] });
            
        },
        onError: (error) => {
            showToast.warning("Failed to Add Beat!");
        },
    });
};

export const useUpdateBeat = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, body }: { id: number; body: any }) =>
            updateBeat(id, body),
        onSuccess: (data) => {
            showToast.success("Update Beat Successfully!");
            queryClient.invalidateQueries({ queryKey: ["BEATS"] });
            queryClient.invalidateQueries({ queryKey: ["BEATS_BY_ID"] });
        },
        onError: (error) => {
            showToast.warning("Failed to Update Beat!");
        },
    });
};

export const useBeatById = ({
    params = {},
    id,
    enable = false,

}: {id?:number; params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["BEATS_BY_ID", params,id],
        queryFn: () => getBeatById(params,id),
        enabled: enable,
        retry: false,
    });
}

export const useBeatOutletsData = ({
    params = {},
    beatId = null,
    enable = false,

}: {beatId?:number|any; params?: Record<string, any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["BEATS", params,beatId],
        queryFn: () => getBeatOutlets(beatId,params),
        enabled: enable,
        retry: false,
    });
}

// Territory Town Filter
export const useGetAllTesearchrritory = ({params={}, enable=false}:{params?:Record<string,any>;enable:boolean,})=>{
    return useQuery({
        queryKey:[params],
        queryFn:()=>getAllTerritory(params),
        retry:false,
        enabled:enable
    })

} 


export const useGetTownsFilter = ({params={}, enable=false}:{params?:Record<string,any>;enable:boolean,})=>{
    return useQuery({
        queryKey:[params],
        queryFn:()=>getTownFilter(params),
        retry:false,
        enabled:enable
    })

} 